export type GeocoderFailureKind = 'network' | 'http' | 'parse';
export type GeocoderProvider = 'photon' | 'nominatim' | 'geoapify';

export class GeocoderError extends Error {
  readonly failureKind: GeocoderFailureKind;
  readonly response?: Response;
  geocoderProvider?: GeocoderProvider;
  geocoderFallbackFrom?: GeocoderProvider;
  geocoderFallbackTrigger?: GeocoderFailureKind | 'empty_results';

  constructor(
    message: string,
    failureKind: GeocoderFailureKind,
    options?: { response?: Response; cause?: unknown }
  ) {
    super(message, options?.cause === undefined ? undefined : { cause: options.cause });
    this.name = 'GeocoderError';
    this.failureKind = failureKind;
    this.response = options?.response;
  }
}
